import { States } from '../../app.router';

/* @ngInject */
export default function orgAlertConfigRouter($stateProvider) {
    $stateProvider
        .state(States.ORGANIZATION_ALERT_CONFIG, {
            url: '/organization-alert-config',
            params: {
                selectedTemplateName: null
            },
            views: {
                'content@main': {
                    component: 'dtOrganizationAlertConfigPage'
                }
            }
        });
} 